/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Empty_JobsInputs */

const vi_print_admin_empty_jobs = /** @type {(inputs: Print_Admin_Empty_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có lệnh in nào`)
};

/**

* @param {Print_Admin_Empty_JobsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_empty_jobs = /** @type {((inputs?: Print_Admin_Empty_JobsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Empty_JobsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_empty_jobs(inputs)
});